import { useState } from "react";
import { useTranslation } from "react-i18next";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { SendByCourierModal } from "../../components/shipping/sendByCourierModal.component";
import { useHasPermission } from "../../contexts/auth";
import { Action } from "../../types/toolbar";

export const ShipmentsListActions = () => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);
  const canAddShipment = useHasPermission("shipping.add_shipment");

  const actions: Action[] = canAddShipment
    ? [
        {
          id: "send-by-courier",
          icon: <LocalShippingIcon />,
          label: t("Send by courier"),
          onClick: () => setOpened(true),
        },
      ]
    : [];

  return (
    <>
      <Toolbar actions={actions} />
      <SendByCourierModal opened={opened} setOpened={setOpened} />
    </>
  );
};
